import { defineCoach } from '../../types';

/** C06: observes the person’s real workflow; navigation is read-only and mutations belong to the page. Arabic copy is DRAFT. */
export const C06 = defineCoach({
  id: 'C06',
  version: 1,
  portal: 'vendor',
  titleKey: 'guidance.coaches.C06.title',
  summaryKey: 'guidance.coaches.C06.summary',
  eligible: (ctx) => ctx.portal === 'vendor',
  steps: [
    {
      id: 'c06-welcome',
      kind: 'explain',
      page: 'vendor.orders',
      anchor: null,
      titleKey: 'guidance.coaches.C06.welcome.title',
      bodyKey: 'guidance.coaches.C06.welcome.body',
      route: 'vendor.orders',
    },
    {
      id: 'c06-open',
      kind: 'await',
      page: 'vendor.orders',
      anchor: 'vendor.orders.list',
      titleKey: 'guidance.coaches.C06.open.title',
      bodyKey: 'guidance.coaches.C06.open.body',
      until: {
        route: 'vendor.order',
      },
    },
    {
      id: 'c06-version',
      kind: 'explain',
      page: 'vendor.order',
      anchor: 'vendor.order.status',
      titleKey: 'guidance.coaches.C06.version.title',
      bodyKey: 'guidance.coaches.C06.version.body',
    },
    {
      id: 'c06-lines',
      kind: 'explain',
      page: 'vendor.order',
      anchor: 'vendor.order.lines',
      titleKey: 'guidance.coaches.C06.lines.title',
      bodyKey: 'guidance.coaches.C06.lines.body',
    },
    {
      id: 'c06-confirm-handoff',
      kind: 'handoff',
      page: 'vendor.order',
      anchor: 'vendor.order.acknowledge',
      titleKey: 'guidance.coaches.C06.confirm-handoff.title',
      bodyKey: 'guidance.coaches.C06.confirm-handoff.body',
      consequenceKey: 'guidance.coaches.C06.confirm-handoff.consequence',
    },
    {
      id: 'c06-confirm',
      kind: 'await',
      page: 'vendor.order',
      anchor: 'vendor.order.acknowledge',
      titleKey: 'guidance.coaches.C06.confirm.title',
      bodyKey: 'guidance.coaches.C06.confirm.body',
      until: {
        outcome: 'vendor.order.acknowledged',
        route: 'vendor.order',
        probe: {
          anchor: 'vendor.order.status',
          in: ['acknowledged'],
        },
      },
    },
    {
      id: 'c06-dispatch-handoff',
      kind: 'handoff',
      page: 'vendor.order',
      anchor: 'vendor.order.dispatch',
      titleKey: 'guidance.coaches.C06.dispatch-handoff.title',
      bodyKey: 'guidance.coaches.C06.dispatch-handoff.body',
      consequenceKey: 'guidance.coaches.C06.dispatch-handoff.consequence',
    },
    {
      id: 'c06-dispatch',
      kind: 'await',
      page: 'vendor.order',
      anchor: 'vendor.order.dispatch',
      titleKey: 'guidance.coaches.C06.dispatch.title',
      bodyKey: 'guidance.coaches.C06.dispatch.body',
      until: {
        outcome: 'vendor.order.dispatched',
        route: 'vendor.order',
        probe: {
          anchor: 'vendor.order.dispatched',
          in: ['dispatched'],
        },
      },
    },
    {
      id: 'c06-result',
      kind: 'explain',
      page: 'vendor.order',
      anchor: 'vendor.order.dispatched',
      titleKey: 'guidance.coaches.C06.result.title',
      bodyKey: 'guidance.coaches.C06.result.body',
    },
    {
      id: 'c06-finish',
      kind: 'finish',
      page: 'vendor.order',
      anchor: null,
      titleKey: 'guidance.coaches.C06.finish.title',
      bodyKey: 'guidance.coaches.C06.finish.body',
    },
  ],
});
